module.exports = __webpack_public_path__ + "c_static/img/mine_img_bg_default@2x.0f153c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/mine_img_bg_default@2x.png
// module id = yfJc
// module chunks = 33